import { z } from 'zod/v3';
import { GraphModel } from '../../graph/graph.model';
import { ok } from 'neverthrow';
import {
  ApplicableContext,
  BaseAction,
  ExecuteContext,
} from '../../actions/framework';
import { Assert } from '@cotera/utilities';
import { DATASET_EDITOR_ACTION_GROUP } from './constants';
import { DatasetModel } from '../model/dataset.model';

type Params = {};

export class ToggleEditorAction extends BaseAction<Params, { t: string }[]> {
  title = 'Toggle Editor';
  description = 'Toggle the editor';
  inputSchema = z.object({});
  group = DATASET_EDITOR_ACTION_GROUP;
  icon = 'collapse';
  shortcut = ['ctrl', 'shift', 'e'];

  applicable(context: ApplicableContext): boolean {
    return (
      context.hasTargetedModelOfType(DatasetModel) &&
      context.isInScope(GraphModel)
    );
  }

  async execute(_: z.infer<typeof this.inputSchema>, context: ExecuteContext) {
    const dataset = context.targetedModelOfType(DatasetModel);
    Assert.assert(dataset !== null, 'Dataset model not found');

    dataset.toggleEditorCollapsed();

    return ok({});
  }
}
